import { render, staticRenderFns } from "./country-language.vue?vue&type=template&id=bdc30182&"
import script from "./country-language.vue?vue&type=script&lang=js&"
export * from "./country-language.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports